import PropTypes from 'prop-types';
import React from 'react';
import { orange } from 'components/v3';
import { brand } from '../../shared/brand';

// The platform mark on the brand-orange tile the design uses (its
// pitpay-200.png). The mark itself is white and red, so on its own it
// vanishes on the light theme's white cards.
const BrandMark = ({ size, radius, title }) => (
  <span
    title={title || undefined}
    style={{
      width: size,
      height: size,
      padding: 3,
      boxSizing: 'border-box',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      alignSelf: 'center',
      borderRadius: radius,
      background: orange(1),
      pointerEvents: 'none',
    }}
  >
    <img
      src={brand().mark}
      alt=""
      style={{
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      }}
    />
  </span>
);

BrandMark.propTypes = {
  size: PropTypes.number.isRequired,
  radius: PropTypes.number,
  title: PropTypes.string,
};

BrandMark.defaultProps = { radius: 5, title: null };

export default BrandMark;
